<template>
  <div
    v-if="formatted"
    class="map-distance-block bg-white border-radius-16 text-bold text-center q-py-8 q-px-12"
  >
    <div class="fs-24 text-grey-10">{{ formatted.distance }}</div>
    <div class="fs-14 text-grey-8">{{ formatted.time }}</div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

import useDistanceAndDuration from '~composables/useDistanceAndDuration';

const { format } = useDistanceAndDuration();

const props = defineProps({
  distance: {
    type: Number,
    default: null,
  },
  time: {
    type: Number,
    default: null,
  },
  isRoundTrip: {
    type: Boolean,
    default: false,
  },
});

const formatted = computed(() => {
  if (props.distance || props.time) {
    return format(props.distance, props.time, props.isRoundTrip, true);
  }
  return null;
});
</script>

<style scoped lang="scss">
.map-distance-block {
  box-shadow: 0 2px 8px rgba(#000, .16);

  @media (max-width: $breakpoint-xs-max) {
    .fs-14 {
      font-size: 12px !important;
    }

    .fs-24 {
      font-size: 18px !important;
    }
  }
}
</style>
